const sportsArticles = [
  {
    title: "Football has had a rocky start to the season. Can it turn things around?",
    author: "Holden Lombardo and Ava Fung",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/14/football-has-had-a-rocky-start-to-the-season-can-it-turn-things-around/",
    image: "https://cloudfront-us-east-1.images.arcpublishing.com/spectator/VIMFSV3PR5D47O3YK5Q6L6CXNQ.jpg"
  },
  {
    title: "Historic Homecomings: How Columbia has fared through the years",
    author: "Jillian Prunty",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/14/historic-homecomings-how-columbia-has-fared-through-the-years/",
    image: "https://www.columbiaspectator.com/resizer/v2/UB46JBBPCRECFB7ECJ7ZF6JWSM.png?auth=7da6238a6f1b84e5274bbeb920fa18bb05aa7df5a4e62fdc4bb3ba576ff407de"
  },
  {
    title: "Lang & Metzger: As the Ivy League falls behind in college football, Columbia faces the consequences",
    author: "Diane Lang and Lucas Metzger",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/15/lang-metzger-college-football-has-changed-and-the-ivy-league-is-falling-behind-columbia-faces-the-consequences/",
    image: "https://www.columbiaspectator.com/resizer/v2/LR3PZWCB3RGJVIVW54PVYEPHTE.jpg?auth=f1c67fe9ffd5d9e2ad0ed8107d05460f5a1e5bc8740864e6e38d938f2e9a72d7"
  },
  {
    title: "The 1961 Lions were an Ivy League championship team. How did the 1962 football team fare?",
    author: "Arielle Rieder",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/15/the-1961-lions-were-an-ivy-league-championship-team-how-did-the-1962-football-team-fare/",
    image: "https://www.columbiaspectator.com/resizer/v2/OHBM2US5ENF5ROUSXV7LKIOJTQ.png?auth=984551be0f8941d2ae0d85f1ed43d205d4c9b6730bdb824b5d0d9f226bd95209"
  },
  {
    title: "In Homecoming matchup, football looks to turn season around against potent Penn offense",
    author: "Andrew Vincenti and Emma Dignan",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/15/in-homecoming-matchup-football-looks-to-turn-season-around-against-potent-penn-offense/",
    image: "https://www.columbiaspectator.com/resizer/v2/RRPHXX6W7FEKXLY4GXZYTCYJDY.jpg?auth=ffa3beb24681acda29a89063a2a8f6f74bfc53117d735ba1dbccf675c54e02d8"
  },
  {
    title: "Last season, Jon Poppe turned Columbia football around. How did he do it?",
    author: "Aidan Hassan, Andrew Vincenti, and Sofía Polar",
    articleLink: "https://www.columbiaspectator.com/sports/2025/10/16/last-season-jon-poppe-turned-columbia-football-around-how-did-he-do-it/",
    image: "https://www.columbiaspectator.com/resizer/v2/KLR256IFZ5A7PNWICEQCJLTNSU.jpg?auth=c13cc6413c46360af5b1c6d49c8e0d12d17466aae7b746500a256f51f6d74c9f"
  }
];
export default sportsArticles;